import { CoreEnums } from '@/utils/domain/constants';

export default {
  lazy: true,
  remote: true,
  type: 'select',
  name: 'remoteField', // This should be overridden
  label: 'global.text.select', // This should be overridden
  locale: true,
  nomenclature: true,
  showSearch: true,
  allowClear: true,
  apiRoute: '', // This should be overridden
  knownType: CoreEnums.FormFieldType.InternalEntity,
  params: {
    select: 'id', // Common default, can be overridden
  },
};
